export const fetchUnifiedProcessing = (response, initValue = null) =>{
    if(response?.code === 200 && response?.result){
        return response?.result;
    }else{
        return initValue;
    }
}


export const disposeComments = (comments, orderItem, Intl) => {
    let initComment = {
        content: '',
        score: 5,
        images: [],
        sizingRecommendation: '2',
        fits: [
            {label: 'small', value: '3'},
            {label: 'True to size', value: '2'},
            {label: 'large', value: '1'}
        ],
        files: [],
        newfiles: []
    };
    if(comments?.length <= 0){
       return orderItem.map((item) =>({ ...item, ...initComment }));
    }

    let newComments = orderItem?.map((order, index) =>{
        let newComment = comments?.find((comment, index) =>comment?.varaintId===order?.variantId);
        if(!!newComment){
            return { ...initComment, ...newComment, ...order }
        }else{
            // 如果匹配到评论与产品的id不匹配的情况下也为这个评论初始化一个产品信息
            return { ...initComment, ...order }
        }
    });

    return newComments;
}   